import styled, { css } from 'styled-components'

type IProps = {
  reduzirNomeUsuario?: boolean
}

const userModifiers = {
  reduzir: () => css`
    max-width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `
}

export const Nav = styled.nav`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 20rem;
  `}
`

export const Username = styled.span`
  ${({ theme }) => css`
    padding: 0 ${theme.spacings.xxsmall};
  `}
`
export const User = styled.div<IProps>`
  ${({ theme, reduzirNomeUsuario }) => css`
    display: flex;
    align-items: center;
    margin: 0 0.5rem;
    > p {
      font-family: ${theme.font.family};
      font-size: ${theme.font.sizes.medium};
      color: ${theme.colors.black};
      margin: 0;
      ${reduzirNomeUsuario && userModifiers.reduzir()};

      > strong {
        font-family: ${theme.font.family};
        font-weight: ${theme.font.bold};
        font-size: 2.4rem;
        color: ${theme.colors.primary};
        margin: 0;
        margin-left: 2px;
      }
    }
  `}
`

export const Link = styled.a`
  ${({ theme }) => css`
    cursor: pointer;
    display: flex;
    align-items: center;
    text-decoration: none;
    background: ${theme.colors.white};
    color: ${theme.colors.black};
    padding: ${theme.spacings.xxsmall} 0;
    margin: 0 ${theme.spacings.small};
    transition: background, color, ${theme.transition.default};
    font-family: ${theme.font.family};
    font-size: ${theme.font.sizes.small};
    &:hover {
      color: ${theme.colors.grayStage};
    }
  `}
`
